"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
import VerifyInput, { VerifyInputController } from "@/components/VerifyInput.vue";
import Cookie from "js-cookie";
export class phoneVerify extends UiFormController {
  constructor() {
    super(...arguments);
    this.phone = "";
    this.verifyCode = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "change_phone_dialog.phone_require"
      ),
      trigger: "blur"
    },
    {
      pattern: /^(1\\d{10})$/,
      message: i18n.t(
        "change_phone_dialog.phone_format"
      ),
      trigger: "blur"
    }
  ])
], phoneVerify.prototype, "phone", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "change_phone_dialog.verify_code_require"
      ),
      trigger: "blur"
    },
    {
      pattern: /^\d{6}$/,
      message: i18n.t(
        "change_phone_dialog.verify_code_format"
      ),
      trigger: "blur"
    }
  ])
], phoneVerify.prototype, "verifyCode", 2);
let ChangePhoneDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.oldPhoneVerify = new phoneVerify();
    this.newPhoneVerify = new phoneVerify();
    this.verifyOldController = new VerifyInputController(
      "api://base.auth/api/v1/verify_code/send",
      13
    );
    this.verifyNewController = new VerifyInputController(
      "api://base.auth/api/v1/verify_code/send",
      0
    );
    this.activeStep = 0;
  }
  open() {
    return __async(this, null, function* () {
      this._changePhoneDialog.show();
      this.oldPhoneVerify.phone = this._controller.phone;
      this.verifyOldController.query.params = {
        phone_prefix: this._controller.phone_prefix
      };
      this.verifyNewController.query.params = {
        phone_prefix: this._controller.phone_prefix
      };
    });
  }
  close() {
    this._changePhoneDialog.hide();
    this.activeStep = 0;
    this.verifyOldController.clearTimer();
    this.verifyNewController.clearTimer();
    this.oldPhoneVerify = new phoneVerify();
    this.newPhoneVerify = new phoneVerify();
  }
  encryptPhone(phone) {
    let _phone = phone;
    if (phone !== null) {
      let arr1 = phone.toString().substring(0, 3);
      let arr2 = phone.toString().substring(phone.toString().length - 4, phone.toString().length);
      _phone = arr1 + "****" + arr2;
    }
    return _phone;
  }
  verifyOldPhone() {
    return __async(this, null, function* () {
      try {
        yield API.post(
          "api://base.auth/api/v1/verify-code",
          {
            codeType: 13,
            phone: this.oldPhoneVerify.phone,
            code: this.oldPhoneVerify.verifyCode
          }
        );
        this.verifyOldController.clearTimer();
        this.activeStep = 1;
        this.oldPhoneVerify.status = "complete";
      } catch (error) {
        this.oldPhoneVerify.status = "complete";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  verifyNewPhone() {
    return __async(this, null, function* () {
      try {
        yield API.put(
          "api://base.auth/api/v1/account-phone",
          {
            phone: this.oldPhoneVerify.phone,
            phoneVerifyCode: this.oldPhoneVerify.verifyCode,
            newPhone: this.newPhoneVerify.phone,
            newphoneVerifyCode: this.newPhoneVerify.verifyCode
          }
        );
        this.activeStep = 3;
        Cookie.set("token", "", { expires: -1 });
        this._controller.phone = this.newPhoneVerify.phone;
        this.newPhoneVerify.status = "complete";
      } catch (error) {
        this.newPhoneVerify.status = "complete";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  logout() {
    this.$router.push("/logout");
  }
};
__decorateClass([
  Ref("changePhoneDialog")
], ChangePhoneDialog.prototype, "_changePhoneDialog", 2);
__decorateClass([
  PropSync("controller", { default: {} })
], ChangePhoneDialog.prototype, "_controller", 2);
ChangePhoneDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      UiSubmit,
      VerifyInput
    }
  })
], ChangePhoneDialog);
export {
  ChangePhoneDialog as default
};
